import { render } from "./AddUserReportDetails.vue?vue&type=template&id=2251f950&scoped=true"
import script from "./AddUserReportDetails.vue?vue&type=script&lang=js"
export * from "./AddUserReportDetails.vue?vue&type=script&lang=js"

import "./AddUserReportDetails.vue?vue&type=style&index=0&id=2251f950&lang=less"
import "./AddUserReportDetails.vue?vue&type=style&index=1&id=2251f950&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2251f950"]])

export default __exports__